import React, { useState } from "react";
// import { motion, AnimatePresence } from 'motion/react';
import { motion, AnimatePresence } from "framer-motion";
import {
  Mail,
  Send,
  ChevronDown,
  CheckCircle2,
  AlertCircle,
  ShieldCheck,
  HelpCircle,
  Loader2,
} from "lucide-react";
import axiosInstanceMainUrl from "../../../utils/axiosInstanceMainUrl";
import { useEffect } from "react";
import Swal from "sweetalert2";
import { MenuItem, TextField } from "@mui/material";

const APIS = [
  {
    id: 1,
    // name: "Commission",
    name: "Send Monthly Fintso Commission Report",
    url: "/commission",
    method: "GET",
    description: " Generates and sends the monthly Fintso commission report.",
  },
  {
    id: 2,
    name: "Send Daily Partner Region-wise Report",
    url: "/admin_panel/partnerreportRegionwise",
    method: "GET",
    description: "Generates and sends the daily partner region-wise report.",
  },
  {
    id: 3,
    name: "Send Monthly Fintso Report",
    url: "/partner/partnermonthlyReportFile",
    method: "POST",
    description: "Generates and sends the monthly report to Fintso by email.",
  },
  {
    id: 4,
    name: "Send Custom Partner Report",
    url: "/admin_panel/monthlyRegionwisereportCustom",
    method: "GET",
    description:
      "Generates and sends the partner report for the selected date range to the marketing team by email.",
  },
  {
    id: 5,
    name: "Send Weekly Partner Region-wise Report",
    url: "/admin_panel/partnerreportWeeklyRegionwise",
    method: "GET",
    description: "Generates and sends the weekly partner region-wise report.",
  },
  {
    id: 6,
    name: "Send Sales Target Report",
    url: "/admin_panel/salesTarget/report",
    method: "GET",
    description: "Generates and sends the sales target report.",
  },
  {
    id: 7,
    name: "Send Daily Partner Region-wise Summary Report",
    url: "/admin_panel/sendRegionwiseSummary",
    method: "GET",
    description:
      "Generates and sends the daily partner region-wise summary report.",
  },
  {
    id: 8,
    name: "Send Welcome Mail with Password",
    url: "/admin_panel/sendcredentialpartner",
    method: "POST",
    needsData: true,
    description:
      "Sends a welcome email with the login password to the MFD, or partner, Flag should be(partner.batuk.gold) format.",
  },
  {
    id: 9,
    name: "Run MMTC-PAMP Redeem Status Update Cron Job",
    url: "/admin_panel/redeemorderupdate",
    method: "GET",
    description: "Updates the status of MMTC-PAMP redemption requests.",
  },
];

export default function SendReport() {
  const [selectedApi, setSelectedApi] = useState(APIS[0]);
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("idle");
  const [errorMessage, setErrorMessage] = useState("");

  // Form data for API 8
  const [formData, setFormData] = useState({
    email: "",
    name: "",
    userName: "",
    password: "",
    flag: "",
    refferealFees: "",
    type: "mfd",
    mmtcRefferalFee: "",
  });
  console.log("Form Data:", formData);
  useEffect(() => {
    document.body.style.overflow = selectedApi.needsData ? "auto" : "hidden";
    // Scroll to top when API selection changes
    window.scrollTo(0, 0);

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [selectedApi]);

  const confirmAndSend = async () => {
    const result = await Swal.fire({
      title: "Confirm Send Mail?",
      text: `You are about to send: ${selectedApi.name}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#4A2A7D",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, send it!",
      didOpen: (modal) => {
        modal.style.marginLeft = "250px";
        modal.style.marginTop = "88px";
      },
    });

    if (result.isConfirmed) {
      handleSend();
    }
  };

  const handleSend = async () => {
    setLoading(true);
    setStatus("idle");

    try {
      const config = {
        method: selectedApi.method,
        url: selectedApi.url,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      console.log("Axios Config:", config);

      if (selectedApi.method === "POST") {
        config.data = selectedApi.needsData ? formData : {};
      }

      const response = await axiosInstanceMainUrl(config);
      console.log(response, "nautiyal<<<<<<<<<<<<<<<<<,");

      setStatus("success");
    } catch (err) {
      setStatus("error");
      const message =
        err.response?.data?.message || err.message || "Something went wrong";
      setErrorMessage(message);
    } finally {
      setLoading(false);
    }
  };
  console.log("shubhamnautiyal>>>>>>>>>>>>>>>>>>>>>>>>.");
  return (
    <div
      style={{ fontFamily: "'Montserrat', sans-serif" }}
      className={`bg-[#FFFFFF]  flex flex-col items-center justify-center p-6 ${
        selectedApi.needsData ? "overflow-y-auto " : ""
      }`}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-[520px] bg-white rounded-xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-200 my-1 mb-32"
      >
        {/* Header */}
        <div className="pt-2 pb-2 flex flex-col items-center">
          <div className="w-12 h-12 bg-[#4A2A7D] rounded-lg flex items-center justify-center text-white mb-3 shadow-lg shadow-[#001f5e1a]">
            <Mail className="w-6 h-6" />
          </div>
          <h1 className="text-2xl font-bold text-[#001f5e] tracking-tight">
            Mail
          </h1>
          {/* <p className="text-slate-500 text-sm mt-1">Utility Suite Mail Dispatcher</p> */}
        </div>

        {/* Form Area */}
        <div className="px-10 pb-10 space-y-6">
          {/* API Selector */}
          <div className="space-y-2">
            <label className="text-[10px] font-bold text-slate-400 uppercase tracking-widest block">
              Select Report to be Send
            </label>

            <div className="relative">
              <select
                value={selectedApi.id}
                onChange={(e) => {
                  const api = APIS.find((a) => a.id === Number(e.target.value));
                  if (api) setSelectedApi(api);
                  setStatus("idle");
                }}
                className="w-full h-11 px-4 pr-10 rounded-lg border border-slate-200 bg-white appearance-none"
              >
                {APIS.map((api) => (
                  <option key={api.id} value={api.id}>
                    {api.name}
                  </option>
                ))}
              </select>

              <ChevronDown className="absolute right-4 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" />
            </div>

            {/* Description */}
            <p className="mt-2 text-sm text-gray-500">
              {selectedApi.description}
            </p>
          </div>

          {/* Conditional Form for Credential Partner */}
          <AnimatePresence mode="wait">
            {selectedApi.needsData && (
              <motion.div
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
                exit={{ opacity: 0, height: 0 }}
                className=" pt-0 !m-0 "
              >
                <div className="grid grid-cols-2 mt-4 gap-4">
                  <TextField
                    label="Full Name"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={formData.name}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        name: e.target.value,
                      }))
                    }
                  />

                  <TextField
                    label="Email Address"
                    variant="outlined"
                    size="small"
                    fullWidth
                    type="email"
                    value={formData.email}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        email: e.target.value,
                      }))
                    }
                  />
                </div>
                <div className="grid grid-cols-2 mt-4 gap-4">
                  {/* <div className="space-y-1">
                    <label className="text-[10px] font-bold  uppercase tracking-widest">
                      Username
                    </label>
                    <input
                      type="text"
                      value={formData.userName}
                      onChange={(e) =>
                        setFormData((p) => ({ ...p, userName: e.target.value }))
                      }
                      className="w-full h-10 px-3 rounded-md border border-slate-200 text-sm outline-none focus:border-[#002878]"
                      style={{
                        borderRadius: "6px",
                        border: "2px solid gray",
                      }}
                    />
                  </div>

                  <div className="space-y-1">
                    <label className="text-[10px] font-bold uppercase tracking-widest">
                      Password
                    </label>
                    <input
                      type="password"
                      value={formData.password}
                      onChange={(e) =>
                        setFormData((p) => ({ ...p, password: e.target.value }))
                      }
                      className="w-full h-10 px-3 rounded-md border border-slate-200 text-sm outline-none focus:border-[#002878]"
                      style={{
                        borderRadius: "6px",
                        border: "2px solid gray",
                      }}
                    />
                  </div> */}
                  <TextField
                    label="Username"
                    size="small"
                    fullWidth
                    value={formData.userName}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        userName: e.target.value,
                      }))
                    }
                  />

                  <TextField
                    label="Password"
                    size="small"
                    type="password"
                    fullWidth
                    value={formData.password}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        password: e.target.value,
                      }))
                    }
                  />
                </div>
                <div className="grid grid-cols-2 mt-4 gap-4">
                  {/* <div className="space-y-1">
                    <label className="text-[10px] font-bold uppercase tracking-widest">
                      Flag
                    </label>
                    <input
                      type="text"
                      value={formData.flag}
                      onChange={(e) =>
                        setFormData((p) => ({ ...p, flag: e.target.value }))
                      }
                      className="w-full h-10 px-3 rounded-md border border-slate-200 text-sm outline-none focus:border-[#002878]"
                      style={{
                        borderRadius: "6px",
                        border: "2px solid gray",
                      }}
                    />
                  </div> */}
                  <TextField
                    label="Flag"
                    size="small"
                    fullWidth
                    value={formData.flag}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        flag: e.target.value,
                      }))
                    }
                  />

                  {/* <div className="space-y-1"> */}
                  {/* <label className="text-[10px] font-bold uppercase tracking-widest">
                      Reffereal Fees
                    </label>
                    <input
                      type="text"
                      value={formData.refferealFees}
                      onChange={(e) =>
                        setFormData((p) => ({
                          ...p,
                          refferealFees: e.target.value,
                        }))
                      }
                      className="w-full h-10 px-3 rounded-md border border-slate-200 text-sm outline-none focus:border-[#002878]"
                      style={{
                        borderRadius: "6px",
                        border: "2px solid gray",
                      }}
                    />
                  </div> */}
                  <TextField
                    label="Referral Fees"
                    size="small"
                    type="number"
                    fullWidth
                    value={formData.refferealFees}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        refferealFees: e.target.value,
                      }))
                    }
                  />
                </div>
                <div className="grid grid-cols-2 mt-4 gap-4">
                  <TextField
                    select
                    label="Type"
                    size="small"
                    fullWidth
                    value={formData.type}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        type: e.target.value,
                      }))
                    }
                  >
                    <MenuItem value="mfd">Welcome Mail</MenuItem>
                    {/* <MenuItem value="employee"></MenuItem> */}
                  </TextField>

                  <TextField
                    label="MMTC Referral Fee"
                    size="small"
                    type="number"
                    fullWidth
                    value={formData.mmtcRefferalFee}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mmtcRefferalFee: e.target.value,
                      }))
                    }
                  />
                </div>
              </motion.div>
            )}
          </AnimatePresence>

          {/* Submit Button */}
          <button
            onClick={confirmAndSend}
            disabled={loading}
            className="w-full h-10 bg-[#4A2A7D] hover:bg-[#002878] text-white rounded-lg font-bold flex items-center justify-center gap-3 transition-all active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed shadow-lg shadow-[#001f5e20]"
          >
            {loading ? (
              <Loader2 className="w-5 h-5 animate-spin" />
            ) : (
              <Send className="w-5 h-5" />
            )}
            <span>Send Mail</span>
          </button>

          {/* Status Messages */}
          <AnimatePresence>
            {status === "success" && (
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                className="p-4 bg-emerald-50 rounded-lg flex items-center gap-3 text-emerald-700 text-sm font-medium border border-emerald-100"
              >
                <CheckCircle2 className="w-5 h-5 flex-shrink-0" />
                <span>
                  Mail request successfully sent to {selectedApi.name}
                </span>
              </motion.div>
            )}
            {status === "error" && (
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                className="p-4 bg-rose-50 rounded-lg flex items-center gap-3 text-rose-700 text-sm font-medium border border-rose-100"
              >
                <AlertCircle className="w-5 h-5 flex-shrink-0" />
                <span>{errorMessage}</span>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </motion.div>
    </div>
  );
}
